import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getAuth } from '../../selectors/access/auth'
import { showLoader, hideLoader } from '../../actions/common'
import messageModalActions from '../../actions/modals/messageModal'
import { fetchCombosSuccess } from '../../actions/combos/combos'
import combosActionTypes from '../../constants/actions/combos/combos'
import { handleError } from '../errors/errorManager'
import getDocumentDataOptions from '../../services/document/getDocumentDataOptions'

export function * fetchDocumentDataOptions ({ optionType }) {
  try {
    yield put(showLoader())
    const auth = yield select(getAuth)
    const documentDataOptionsCombo = yield call(getDocumentDataOptions, auth.token, optionType)
    yield put(fetchCombosSuccess({ documentDataOptionsCombo }))
  } catch (error) {
    const customHandler = function * () {
      yield put(messageModalActions.openErrorMessageModal('MESSAGES.FETCH_COMBO_ERROR'))
    }
    yield call(handleError, { error, customHandler })
  } finally {
    yield put(hideLoader())
  }
}

export function * watchfetchDocumentDataOptions () {
  yield takeLatest(combosActionTypes.FETCH_DOCUMENT_DATA_OPTIONS, fetchDocumentDataOptions)
}
